async function parseJson(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || 'Request failed.');
    error.validationErrors = data.validationErrors || [];
    throw error;
  }
  return data;
}

export async function fetchSettingsBootstrap() {
  const response = await fetch('/api/settings/bootstrap');
  return parseJson(response);
}

export async function createLocation(payload) {
  const response = await fetch('/api/settings/locations', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJson(response);
}

export async function updateLocation(locationId, payload) {
  const response = await fetch(`/api/settings/locations/${locationId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJson(response);
}

export async function copyLocation(locationId, payload) {
  const response = await fetch(`/api/settings/locations/${locationId}/copy`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJson(response);
}

export async function deleteLocation(locationId) {
  const response = await fetch(`/api/settings/locations/${locationId}`, {
    method: 'DELETE',
  });
  return parseJson(response);
}

export async function setActiveLocation(locationId) {
  const response = await fetch('/api/settings/active-location', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ locationId }),
  });
  return parseJson(response);
}

export async function fetchLocationSkills(locationId) {
  const response = await fetch(`/api/settings/locations/${locationId}/skills`);
  return parseJson(response);
}

export async function saveLocationSkills(locationId, payload) {
  const response = await fetch(`/api/settings/locations/${locationId}/skills`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJson(response);
}

export async function saveLocationCampers(locationId, payload) {
  const response = await fetch(`/api/settings/locations/${locationId}/campers`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJson(response);
}

export async function createStaffTeam(payload) {
  const response = await fetch('/api/settings/staff-teams', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJson(response);
}

export async function updateStaffTeam(teamId, payload) {
  const response = await fetch(`/api/settings/staff-teams/${teamId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return parseJson(response);
}

export async function deleteStaffTeam(teamId) {
  const response = await fetch(`/api/settings/staff-teams/${teamId}`, {
    method: 'DELETE',
  });
  return parseJson(response);
}
